import { MotionBox } from "utils/motion";
import Button from "components/base/Button";

const hoverLiftVariants = { regular: { y: 0 }, selected: { y: -5 } };

const SocialLink = ({ href, children, ariaLabel, ...props }) => (
  <Button
    rel="noopener noreferrer"
    target="_blank"
    href={href}
    aria-label={ariaLabel}
    variant="unstyled"
  >
    <MotionBox
      variants={hoverLiftVariants}
      initial="regular"
      whileHover="selected"
      {...props}
    >
      {children}
    </MotionBox>
  </Button>
);

export const SocialButton = ({ children, ...props }) => (
  <MotionBox
    variants={hoverLiftVariants}
    initial="regular"
    _hover={{ cursor: "pointer" }}
    whileHover="selected"
    {...props}
  >
    {children}
  </MotionBox>
);

export default SocialLink;
